// Where a logged-out visitor was headed, so login can take them there instead of always to
// /dashboard. Before 2026-09-24 the report email's "Log in to view your full report" logged
// the customer in and then showed the dashboard, because the guard (layouts/fullLayout.js)
// redirected to /auth/login with no memory of the page asked for.
//
// Only same-site paths are ever accepted — never a URL, a protocol-relative "//host", or an
// /auth page — so this can't be turned into an open redirect.

const KEY = "dmi-return-to";

export const safeReturnPath = (path) => {
  if (typeof path !== "string" || !path.startsWith("/")) return null;
  if (path.startsWith("//") || path.includes("\\")) return null;
  if (path === "/" || path.startsWith("/auth") || path.startsWith("/dashboard"))
    return null;
  return path;
};

// Also kept in sessionStorage, because the router state is lost if the login page reloads.
export const rememberReturnTo = (path) => {
  const safe = safeReturnPath(path);
  if (!safe) return null;
  try {
    window.sessionStorage.setItem(KEY, safe);
  } catch (e) {
    // storage blocked: the router state still carries it
  }
  return safe;
};

export const takeReturnTo = () => {
  try {
    const v = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return safeReturnPath(v);
  } catch (e) {
    return null;
  }
};
